var _path, _rect, _g, _path2, _path3, _rect2, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect3, _g3, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 275C65.4 275 5 214.6 5 140C5 65.4 65.4 5 140 5C214.6 5 275 65.4 275 140C275 214.6 214.6 275 140 275Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_38",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 235,
    width: 70,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 235,
    width: 70,
    height: 12,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.2 244.9C137.204 244.9 151.8 243.199 151.8 241.1C151.8 239.001 137.204 237.3 119.2 237.3C101.196 237.3 86.6 239.001 86.6 241.1C86.6 243.199 101.196 244.9 119.2 244.9Z",
    fill: "#BFC3CE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6 238C107.001 238 113 234.239 113 229.6C113 224.961 107.001 221.2 99.6 221.2C92.1994 221.2 86.2 224.961 86.2 229.6C86.2 234.239 92.1994 238 99.6 238Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 229.6C104.9 229.6 103.6 228.4 103.5 226.9C103.5 226.6 103.3 226.2 103.2 225.9L97.9 214.6C97.5 213.9 97.5 213 97.8 212.2L103.3 198.4C103.4 198.2 103.4 197.9 103.5 197.7C103.7 196.2 105 195 106.5 195C107.2 195 107.9 195.3 108.4 195.7C109.4 196.5 109.6 197.9 109.2 199L103.9 212.2C103.6 213 103.6 213.8 104 214.6L109 225.3C109.8 227.1 108.8 229.3 106.8 229.5C106.7 229.6 106.6 229.6 106.5 229.6Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_38",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 223,
    width: 8,
    height: 9
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 223,
    width: 8,
    height: 9,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 229.6C93.0493 229.6 93.9 228.749 93.9 227.7C93.9 226.651 93.0493 225.8 92 225.8C90.9507 225.8 90.1 226.651 90.1 227.7C90.1 228.749 90.9507 229.6 92 229.6Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2 136.3C89.2 136.3 69.8 166.2 78.2 187.7",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.9 224.9C203.7 226.3 203.2 227.8 202.4 229.4C202.3 229.5 202.3 229.7 202.2 229.8C201 232.1 199.2 234.6 196.9 237.7C196.8 237.8 196.7 238 196.6 238.1C188.9 244 171 241.5 164.8 240.5C163.6 240.3 162.8 240.1 162.7 240.1C112.4 219.2 77.7 175.1 77.7 124.1C77.7 99.5 85.7 76.6 99.7 57.1C101.4 54.7 116.5 42.2 124.5 38.8C125.6 38.3 128.3 37.4 130.7 36.5C132.5 35.9 134.2 35.3 134.8 35.1C136.7 35.5 139 36.6 141.2 38.2C142.4 39.1 143.5 40 144.4 41C145 41.6 145.5 42.3 145.9 42.9C146.8 44.2 147.2 45.3 147.1 46.3C147.1 46.5 146.7 47.3 146.7 47.3C146.5 47.7 142.8 66.1 140.5 72.4C140.5 72.5 140.4 72.6 140.4 72.7C135.5 85 133 98.2 133 112C133 156.7 159.6 196 199.9 219.1C199.9 219.1 199.9 219.1 200 219.1C200 219.1 200.1 219.2 200.2 219.2C200.3 219.2 200.3 219.3 200.4 219.3L200.5 219.4C201.5 220 203.4 221.4 203.8 223.4C203.9 223.9 203.9 224.4 203.9 224.9Z",
    fill: "#FDD338"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.4 224.9C203.2 226.3 202.7 227.8 201.9 229.4C201.8 229.5 201.8 229.7 201.7 229.8C201.6 230 201.5 230.1 201.4 230.3C156.9 208.7 125.3 169.3 120.4 121.7C118.8 106.5 120.1 91.5 123.9 77.2C123.9 77.1 124 77 124 76.8C125.9 69.6 129.9 60.4 130.1 60C130.1 60 132.1 57 133.1 55.1L135.1 50.2C135.1 49.2 138.5 36.8 140.6 38.3C141.8 39.2 142.9 40.1 143.8 41.1C144.4 41.7 144.9 42.4 145.3 43C146.2 44.3 146.6 45.4 146.5 46.4C146.5 46.6 146.1 47.4 146.1 47.4C145.9 47.8 142.2 66.2 139.9 72.5C139.9 72.6 139.8 72.7 139.8 72.8C135.1 85.2 132.6 98.5 132.6 112.2C132.6 156.9 159.2 196.2 199.5 219.3C199.5 219.3 199.5 219.3 199.6 219.3C199.6 219.3 199.7 219.4 199.8 219.4C199.9 219.4 199.9 219.5 200 219.5L200.1 219.6C201.1 220.2 203 221.6 203.4 223.6C203.4 223.9 203.4 224.4 203.4 224.9Z",
    fill: "#FBDC6F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.1 241.8C177.2 242.6 168.3 241.3 164.3 240.6C163.1 240.4 162.3 240.2 162.2 240.2C111.9 219.3 77.2 175.2 77.2 124.2C77.2 99.6 85.2 76.7 99.2 57.2C100.9 54.8 116 42.3 124 38.9C125.1 38.4 127.8 37.5 130.2 36.6C131.7 36.1 133 35.6 133.8 35.4C134.1 35.3 134.8 36.2 135.1 36.3C135.3 36.4 134.9 36.2 135.1 36.3C136.7 36.8 137.1 38.2 135.6 38.9C127.5 42.3 112.4 54.8 110.8 57.2C96.9 76.7 88.8 99.7 88.8 124.2C88.8 175.3 123.5 219.4 173.8 240.2C173.9 240.2 174.7 240.4 175.9 240.6C177.9 240.9 181.2 241.5 185.1 241.8Z",
    fill: "#E9B446"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130 141.9C130 141.9 138.9 176.4 124.1 194.1",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7 136.2C87.4614 136.2 89.7 133.961 89.7 131.2C89.7 128.439 87.4614 126.2 84.7 126.2C81.9386 126.2 79.7 128.439 79.7 131.2C79.7 133.961 81.9386 136.2 84.7 136.2Z",
    fill: "#4C1A1D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.9 133.5C111.9 130.7 114.1 128.5 116.9 128.5C119.7 128.5 121.9 130.7 121.9 133.5",
    fill: "#4C1A1D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6 139.7C110.7 144.2 107.9 148.8 103.4 149.9C98.9 151 94.3 148.2 93.2 143.7",
    fill: "#4C1A1D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.2 239.6C134.601 239.6 140.6 235.839 140.6 231.2C140.6 226.561 134.601 222.8 127.2 222.8C119.799 222.8 113.8 226.561 113.8 231.2C113.8 235.839 119.799 239.6 127.2 239.6Z",
    fill: "#3A3A3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.5 231.2C132.9 231.2 131.6 230 131.5 228.5C131.5 228.2 131.3 227.8 131.2 227.5L125.9 216.2C125.5 215.5 125.5 214.6 125.8 213.8L131.3 200C131.4 199.8 131.4 199.5 131.5 199.3C131.7 197.8 133 196.6 134.5 196.6C135.2 196.6 135.9 196.9 136.4 197.3C137.4 198.1 137.6 199.5 137.2 200.6L131.9 213.8C131.6 214.6 131.6 215.4 132 216.2L137 226.9C137.8 228.7 136.8 230.9 134.8 231.1C134.7 231.2 134.6 231.2 134.5 231.2Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_38",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 226,
    width: 9,
    height: 8
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 226,
    width: 9,
    height: 8,
    fill: "url(#pattern2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.3 231.9C121.349 231.9 122.2 231.049 122.2 230C122.2 228.951 121.349 228.1 120.3 228.1C119.251 228.1 118.4 228.951 118.4 230C118.4 231.049 119.251 231.9 120.3 231.9Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.3 35.3C134.1 35.3 134 35.4 134 35.6C133.9 37.2 133.9 44.1 139.4 45.8C144.8 47.5 146.6 46.3 147 45.9C147.1 45.8 147.1 45.8 147.1 45.7C146.9 44.7 146 38.2 134.3 35.3Z",
    fill: "#FDD338"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_38",
    transform: "scale(0.0142857 0.0833333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_38",
    transform: "scale(0.125 0.111111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_1_38",
    transform: "scale(0.111111 0.125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_38",
    width: 70,
    height: 12,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGiAAAB4QAAAmD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAwARgMBIgACEQEDEQH/xACIAAACAwEAAAAAAAAAAAAAAAAABgEEBQIBAQAAAAAAAAAAAAAAAAAAAAAQAAAEBAcBAAAAAAAAAAAAAAACBAUgEiYXAREDEwYWBxURAAAFAQUGBwEAAAAAAAAAAAABEQISMUHRogNEIaGSEwQUELEyQlJigiQSAQAAAAAAAAAAAAAAAAAAACD/2gAMAwEAAhEDEQAAAExqStIfOlQGsVAZcOpjkFMP/9oACAECAAEFAIf/2gAIAQMAAQUAh//aAAgBAQABBQBvbTLjI+AJlOBPOGXAtuWIW5YhbliCjzdpNpruDp0xDN+Swk86HsO7XQroV0K6B+8Za/15h//aAAgBAgIGPwA//9oACAEDAgY/AD//2gAIAQEBBj8AiWa3Ls2gl6wyM6pG4FJzzO05HeKv4jvFX8R3ir+I7wZZOa/Ld8pL5qHGzq1cVFRNwb0vNacvfYSAuWs7I13D+PuJp9kT97BqMI1GEajCNRhBy7hLfSHc/uFU5Sml3h//2Q=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_38",
    width: 8,
    height: 9,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAF0AAABgQAAAaj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAkACAMBIgACEQEDEQH/xABoAAEBAQAAAAAAAAAAAAAAAAAABAYBAQAAAAAAAAAAAAAAAAAAAAAQAQADAAAAAAAAAAAAAAAAAAATBBURAAEEAwAAAAAAAAAAAAAAABEQMRITQjMkEgEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAAADGIh//2gAIAQIAAQUAf//aAAgBAwABBQB//9oACAEBAAEFAIKOW//aAAgBAgIGPwB//9oACAEDAgY/AH//2gAIAQEBBj8Aut7J6jiQyf/Z"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_1_38",
    width: 9,
    height: 8,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAFyAAABfwAAAaf/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAgACQMBIgACEQEDEQH/xABmAAEBAQAAAAAAAAAAAAAAAAAABAYBAQAAAAAAAAAAAAAAAAAAAAAQAQEBAAAAAAAAAAAAAAAAAAAVAhEBAAIDAQAAAAAAAAAAAAAAEQESECFhFBIBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAAAAxsIf/9oACAECAAEFAH//2gAIAQMAAQUAf//aAAgBAQABBQDMuc//2gAIAQICBj8Af//aAAgBAwIGPwB//9oACAEBAQY/AJvf3sg1HXMf/9k="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanana);
export default __webpack_public_path__ + "static/media/banana.577cb38d7f20a2a7289b4e3d330fca81.svg";
export { ForwardRef as ReactComponent };